let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kNFvF"), load("kVX56"), load("7PoP4")]).then(() => parcelRequire('l7IUB'));